import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Login from "./pages/Auth/Login";
import PrivateRoute from "./components/PrivateRoute";
import OfferDetailsPage from "./pages/Marketplace/OfferDetailsPage";
import SupportPage from "./pages/Support/SupportPage";
import SuperPrivateRoute from "./components/SuperAdminPrivateRoute";
import SuperManageUsersPage from "./pages/SuperDashboard/SuperManageUsersPage";
import { Toaster } from "react-hot-toast";
import OfferPage from "./pages/Marketplace/MarketplaceOfferPage";
import TopBar from "./components/TopBar";
import SuperManageSupplyPage from "./pages/SuperDashboard/SuperManageSupplyPage";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import SuperManageOffersPage from "./pages/SuperDashboard/SuperManageOffersPage";
import SuperManageSpecsPage from "./pages/SuperDashboard/SuperManageSpecsPage";
import SpecsPage from "./pages/Specs/SpecsPage";

function AppRoutes() {
  const token = localStorage.getItem("access_token");
  const location = useLocation();

  return (
    <>
      {location.pathname !== "/login" && location.pathname !== "/forgot" && <TopBar />}

      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route
          path="/login"
          element={token ? <Navigate to="/offers" replace /> : <Login />}
        />
        <Route
          path="/forgot"
          element={
            <ForgotPassword />
          }
        />
        <Route
          path="/offers"
          element={
            <PrivateRoute>
              <OfferPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/specs"
          element={
            <SpecsPage />
          }
        />
        <Route
          path="/offers/:id"
          element={
            <PrivateRoute>
              <OfferDetailsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/support"
          element={
            <PrivateRoute>
              <SupportPage />
            </PrivateRoute>
          }
        />
        <Route path="/admin" element={<SuperPrivateRoute />}>
          <Route path="users" element={<SuperManageUsersPage />} />
          <Route path="manageoffers" element={<SuperManageOffersPage />} />
          <Route path="supply" element={<SuperManageSupplyPage />} />
          <Route path="specs" element={<SuperManageSpecsPage />} />

        </Route>

        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes >
    </>
  );
}

export default function App() {
  return (
    <>
      <Toaster />
      <AppRoutes />
    </>
  );
}
